import React, { useState, useMemo, useEffect } from 'react';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../atom/ModalAtom';
import { userIdState } from '../atom/TokenAtom';
import Header1 from '../component/Header1';
import { MyRoomsDto } from '../model/room.dto';
import { tokenTriggerRecoil, accessTokenRecoil } from '../atom/UserAtom';
import { roomAPI } from '../api/axiosIndex';
import { Icon } from '../component/Icon';
import { fullLoadingStateRecoil } from '../atom/CommonAtom';

const MyRoomList = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);
  const [tokenTrigger, setTokenTrigger] = useRecoilState(tokenTriggerRecoil);

  const navigate = useNavigate();

  const [accessToken, setAccessToken] = useRecoilState(accessTokenRecoil);

  const [rooms, setRooms] = useState<MyRoomsDto>();
  const [searchRooms, setSearchRooms] = useState<MyRoomsDto>();
  const [searchTitle, setSearchTitle] = useState('');
  const [searchLastTitle, setSearchLastTitle] = useState('');
  const [selectRoomId, setSelectRoomId] = useState<number>(0);

  const fetchRooms = async () => {
    try {
      const response = await roomAPI.getMyRooms();
      const sortedRooms = response
        ? [...response.data].sort((a, b) => {
            if (a.master === b.master) {
              return b.id - a.id;
            }
            return a.master ? -1 : 1;
          })
        : [];
      setRooms(sortedRooms);
    } catch (err: any) {
      console.error(err);
    }
  };

  const handleSearch = () => {
    const filtered = rooms?.filter((room) => room.title.includes(searchTitle));
    setSearchLastTitle(searchTitle);
    setSearchRooms(filtered);
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  return (
    <>
      <Header1 title="내 방 목록" />
      <LS.MainCntLayout>
        <CS.SearchBox>
          <input
            type="text"
            placeholder="방 제목 입력"
            value={searchTitle}
            onChange={(e) => setSearchTitle(e.target.value)}
          />
          <button className="img-box" onClick={handleSearch}>
            <Icon name="SearchIcon" size="100%" color="#fff" />
          </button>
        </CS.SearchBox>
        {searchRooms && (
          <CS.SearchResultText>
            &quot;{searchLastTitle}&quot;에 대한 검색 결과 입니다.
          </CS.SearchResultText>
        )}
        {searchRooms && (
          <LS.RoomListBox>
            {searchRooms?.map((room) => (
              <CS.RoomList key={room.id}>
                <div className="text-box">
                  <div className="title-box">
                    {room.master && (
                      <span className="img-box">
                        <Icon
                          name="KingBgIcon"
                          size="100%"
                          color="#ffffff"
                          color2="#FABC43"
                        />
                      </span>
                    )}
                    <h1>{room.title}</h1>
                  </div>
                  {/* <div className="people-num-box">
                    <span>인원</span>
                    <span className="num">{room.personnel}</span>
                  </div> */}
                </div>
                <button
                  type="button"
                  onClick={() => {
                    navigate(`/roomdetail/${room.id}`);
                  }}
                  className="entry-btn"
                >
                  입장
                </button>
              </CS.RoomList>
            ))}
          </LS.RoomListBox>
        )}
        {!searchRooms && (
          <LS.RoomListBox>
            {rooms?.map((room) => (
              <CS.RoomList key={room.id}>
                <div className="text-box">
                  <div className="title-box">
                    {room.master && (
                      <span className="img-box">
                        <Icon
                          name="KingBgIcon"
                          size="100%"
                          color="#ffffff"
                          color2="#FABC43"
                        />
                      </span>
                    )}
                    <h1>{room.title}</h1>
                  </div>
                  {/* <div className="people-num-box">
                    <span>인원</span>
                    <span className="num">{room.personnel}</span>
                  </div> */}
                </div>
                <button
                  type="button"
                  onClick={() => {
                    navigate(`/roomdetail/${room.id}`);
                  }}
                  className="entry-btn"
                >
                  입장
                </button>
              </CS.RoomList>
            ))}
          </LS.RoomListBox>
        )}
      </LS.MainCntLayout>
    </>
  );
};

export default MyRoomList;
